<nav [attr.aria-label]="'greenManure.steps' | translate">
  @for (step of steps(); track step.labelKey; let index = $index) {
    <div
      class="step"
      [class.active]="activeStep() === index + 1"
      [class.completed]="step.completed"
      [class.review]="step.labelKey === 'greenManure.review'"
    >
      <button
        type="button"
        [disabled]="step.disabled ?? false"
        [attr.aria-current]="activeStep() === index + 1 ? 'step' : null"
        (click)="stepSelected.emit(index + 1)"
      >
        <span class="step-number">{{ index + 1 }}</span>
        <span class="step-name">{{ step.labelKey | translate }}</span>
      </button>
      <div class="connector" aria-hidden="true">
        <span class="dot"></span>
        @if (!$last) {
          <span class="line"></span>
        }
      </div>
    </div>
  }
</nav>
